import { render, staticRenderFns } from "./ResultView.vue?vue&type=template&id=28f0f91e&scoped=true"
import script from "./ResultView.vue?vue&type=script&lang=ts"
export * from "./ResultView.vue?vue&type=script&lang=ts"
import style0 from "./ResultView.vue?vue&type=style&index=0&id=28f0f91e&prod&scoped=true&lang=css"
import style1 from "./ResultView.vue?vue&type=style&index=1&id=28f0f91e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f0f91e",
  null
  
)

export default component.exports